import type {SearchTemplateColumn} from 'src/modules/advanced-search-result/typedef';
import type {ProductSummary} from 'src/openapi/admin/models/ProductSummary';

const PRODUCT_PREFIX = 'PRODUCT:';

export const isProductColumn = (code: string) => code.startsWith(PRODUCT_PREFIX);

export const buildProductColumns = (products: ProductSummary[]): SearchTemplateColumn[] => products.map(product => ({
    code: `${PRODUCT_PREFIX}${product.productExternalKey}`,
    name: product.name,
    required: false,
}));

export const visibleColumnIds = (ids: string[], products: ProductSummary[]): string[] => {
    const activeCodes = new Set(buildProductColumns(products).map(({code}) => code));
    return ids.filter(code => !isProductColumn(code) || activeCodes.has(code));
};

export const mergeTemplateColumns = (
    selected: string[],
    previous: Record<string, number>,
    available: string[],
    reset = false,
): Record<string, number> => {
    const ordered = selected.filter(code => available.includes(code));
    if (!reset) {
        Object.entries(previous)
            .filter(([code]) => isProductColumn(code) && !available.includes(code))
            .sort((a, b) => a[1] - b[1])
            .forEach(([code, position]) => ordered.splice(Math.min(position, ordered.length), 0, code));
    }
    return Object.fromEntries(ordered.map((code, index) => [code, index]));
};

export const getProductAccessValue = (
    data: Record<string, string[]>, userId: number, column: string,
): string => data[userId]?.includes(column.slice(PRODUCT_PREFIX.length)) ? 'Yes' : '';
